export const AIQ_REPORT_START_DATE = new Date('2026-10-30T00:00:00+09:00')

export function isAiqReportDateLocked(now: Date = new Date()): boolean {
  return now < AIQ_REPORT_START_DATE
}
